export const ORDINALS = [
  '',
  'First',
  'Second',
  'Third',
  'Fourth',
  'Fifth',
  'Sixth',
  'Seventh',
  'Eighth',
  'Ninth',
  'Tenth',
  'Eleventh',
  'Twelfth',
  'Thirteenth',
  'Fourteenth',
  'Fifteenth',
  'Sixteenth',
  'Seventeenth',
  'Eighteenth',
  'Nineteenth',
  'Twentieth',
  'Twenty-First',
  'Twenty-Second',
  'Twenty-Third',
  'Twenty-Fourth',
  'Twenty-Fifth',
  'Twenty-Sixth',
  'Twenty-Seventh',
  'Twenty-Eighth',
  'Twenty-Ninth',
  'Thirtieth',
  'Thirty-First',
  'Thirty-Second',
  'Thirty-Third',
  'Thirty-Fourth',
  'Thirty-Fifth',
  'Thirty-Sixth',
  'Thirty-Seventh',
  'Thirty-Eighth',
  'Thirty-Ninth',
  'Fortieth',
  'Forty-First',
  'Forty-Second',
  'Forty-Third',
  'Forty-Fourth',
  'Forty-Fifth',
  'Forty-Sixth',
  'Forty-Seventh',
  'Forty-Eighth',
  'Forty-Ninth',
  'Fiftieth',
  'Fifty-First',
  'Fifty-Second',
  'Fifty-Third',
  'Fifty-Fourth',
  'Fifty-Fifth',
  'Fifty-Sixth',
  'Fifty-Seventh',
  'Fifty-Eighth',
  'Fifty-Ninth',
  'Sixtieth',
  'Sixty-First',
  'Sixty-Second',
  'Sixty-Third',
  'Sixty-Fourth',
  'Sixty-Fifth',
  'Sixty-Sixth',
  'Sixty-Seventh',
  'Sixty-Eighth',
  'Sixty-Ninth',
  'Seventieth',
  'Seventy-First',
  'Seventy-Second',
  'Seventy-Third',
  'Seventy-Fourth',
  'Seventy-Fifth',
  'Seventy-Sixth',
  'Seventy-Seventh',
  'Seventy-Eighth',
  'Seventy-Ninth',
  'Eightieth',
  'Eighty-First',
  'Eighty-Second',
  'Eighty-Third',
  'Eighty-Fourth',
  'Eighty-Fifth',
  'Eighty-Sixth',
  'Eighty-Seventh',
  'Eighty-Eighth',
  'Eighty-Ninth',
  'Ninetieth',
  'Ninety-First',
  'Ninety-Second',
  'Ninety-Third',
  'Ninety-Fourth',
  'Ninety-Fifth',
  'Ninety-Sixth',
  'Ninety-Seventh',
  'Ninety-Eighth',
  'Ninety-Ninth'
];

// Only used for days of the month at the moment.
export const NUMERIC_ORDINALS = [
  '',
  '1st',
  '2nd',
  '3rd',
  '4th',
  '5th',
  '6th',
  '7th',
  '8th',
  '9th',
  '10th',
  '11th',
  '12th',
  '13th',
  '14th',
  '15th',
  '16th',
  '17th',
  '18th',
  '19th',
  '20th',
  '21st',
  '22nd',
  '23rd',
  '24th',
  '25th',
  '26th',
  '27th',
  '28th',
  '29th',
  '30th',
  '31st'
];
